export const environment = {
  production: false,
  baseUrl: 'https://info-ecology.com/back/controller.php',
};
